// Suggestions & Sort
export const SUGGESTIONS = ["user interface", "user experience", "web design", "interface", "app"];

export const SORT_OPTIONS = ["Trending", "Most Popular", "Newest", "Highest Rated", "Price: Low to High", "Price: High to Low"];

// Sidebar: Categories
export const CATEGORIES = [
    {
        id: "development",
        label: "Development",
        icon: "bi-grid-1x2",
        children: [
            { id: "web-dev", label: "Web development", count: 574 },
            { id: "data-sci", label: "Data Science", count: 508 },
            { id: "mobile-dev", label: "Mobile Development", count: 1345, active: true },
            { id: "sw-testing", label: "Software Testing", count: 317 },
            { id: "sw-eng", label: "Software Engineering", count: 31 },
            { id: "sw-tools", label: "Software Development Tools", count: 508 },
            { id: "no-code", label: "No-Code Development", count: 7 },
        ],
    },
    {
        id: "business",
        label: "Business",
        icon: "bi-briefcase",
        children: [
            { id: "bus-comm", label: "Communication", count: 245 },
            { id: "bus-mgmt", label: "Management", count: 189 },
            { id: "bus-sales", label: "Sales", count: 134 },
            { id: "bus-strat", label: "Strategy", count: 98 },
        ],
    },
    {
        id: "finance",
        label: "Finance & Accounting",
        icon: "bi-calculator",
        children: [
            { id: "fin-acc", label: "Accounting", count: 156 },
            { id: "fin-invest", label: "Investing", count: 78 },
            { id: "fin-crypto", label: "Cryptocurrency", count: 432 },
        ],
    },
    {
        id: "it",
        label: "IT & Software",
        icon: "bi-laptop",
        children: [
            { id: "it-cert", label: "IT Certification", count: 856 },
            { id: "it-nw", label: "Network & Security", count: 432 },
            { id: "it-os", label: "Operating Systems", count: 123 },
        ],
    },
    {
        id: "office",
        label: "Office Productivity",
        icon: "bi-file-earmark-text",
        children: [
            { id: "off-excel", label: "Microsoft Excel", count: 1543 },
            { id: "off-goog", label: "Google Docs", count: 432 },
            { id: "off-sap", label: "SAP", count: 87 },
        ],
    },
    {
        id: "personal",
        label: "Personal Development",
        icon: "bi-person-check",
        children: [
            { id: "pers-conf", label: "Self Confidence", count: 654 },
            { id: "pers-time", label: "Time Management", count: 321 },
            { id: "pers-lead", label: "Leadership", count: 432 },
        ],
    },
    {
        id: "design",
        label: "Design",
        icon: "bi-palette",
        children: [
            { id: "des-web", label: "Web Design", count: 876 },
            { id: "des-graphic", label: "Graphic Design", count: 543 },
            { id: "des-uiux", label: "UI/UX Design", count: 1234 },
        ],
    },
    {
        id: "marketing",
        label: "Marketing",
        icon: "bi-megaphone",
        children: [
            { id: "mkt-digital", label: "Digital Marketing", count: 945 },
            { id: "mkt-seo", label: "SEO", count: 321 },
            { id: "mkt-social", label: "Social Media Marketing", count: 654 },
        ],
    },
    {
        id: "lifestyle",
        label: "Lifestyle",
        icon: "bi-heart",
        children: [
            { id: "life-cook", label: "Cooking", count: 432 },
            { id: "life-pet", label: "Pet Training", count: 123 },
            { id: "life-travel", label: "Travel", count: 87 },
        ],
    },
    {
        id: "photo",
        label: "Photography & Video",
        icon: "bi-camera",
        children: [
            { id: "pho-digi", label: "Digital Photography", count: 654 },
            { id: "pho-edit", label: "Video Editing", count: 321 },
            { id: "pho-comm", label: "Commercial Photography", count: 98 },
        ],
    },
    {
        id: "music",
        label: "Music",
        icon: "bi-music-note-beamed",
        children: [
            { id: "mus-instr", label: "Instruments", count: 876 },
            { id: "mus-prod", label: "Music Production", count: 432 },
            { id: "mus-vocal", label: "Vocals", count: 123 },
        ],
    },
    {
        id: "health",
        label: "Health & Fitness",
        icon: "bi-activity",
        children: [
            { id: "heal-yoga", label: "Yoga", count: 543 },
            { id: "heal-med", label: "Meditation", count: 321 },
            { id: "heal-gym", label: "Fitness", count: 654 },
        ],
    },
];

// Sidebar: Tools
export const TOOLS = [
    { id: "html5", label: "HTML 5", count: 1345 },
    { id: "css3", label: "CSS 3", count: 12134 },
    { id: "react", label: "React", count: 1345 },
    { id: "webflow", label: "Webflow", count: 1345, active: true },
    { id: "nodejs", label: "Node.js", count: 1345 },
    { id: "laravel", label: "Laravel", count: 1345 },
    { id: "sass", label: "Sass", count: 1345 },
    { id: "wordpress", label: "Wordpress", count: 1345 },
];

// Sidebar: Ratings
export const RATINGS = [
    { id: "5star", label: "5 Star", value: 5 },
    { id: "4star", label: "4 Star & up", value: 4 },
    { id: "3star", label: "3 Star & up", value: 3, active: true },
    { id: "2star", label: "2 Star & up", value: 2 },
    { id: "1star", label: "1 Star & up", value: 1 },
];

// Sidebar: Levels
export const LEVELS = ["All Level", "Beginner", "Intermediate", "Expert"];

// Sidebar: Durations
export const DURATIONS = [
    { id: "6-12mo", label: "6-12 Months" },
    { id: "3-6mo", label: "3-6 Months" },
    { id: "1-3mo", label: "1-3 Months", active: true },
    { id: "1-4wk", label: "1-4 Weeks" },
    { id: "1-7d", label: "1-7 Days" },
];

// Courses
const IMAGES = [
    "https://images.unsplash.com/photo-1531482615713-2afd69097998?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=220&fit=crop",
    "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=220&fit=crop",
];

const CATEGORIES_LIST = ["IT & SOFTWARE", "DEVELOPMENTS", "MARKETING", "DESIGN"];
const CAT_COLORS = ["primary", "info", "success", "theme1"];
const PRICES = ["$35", "$16", "$23", "$32", "$24", "$9", "$89", "$32", "$49", "$9", "$9", "$24", "$24", "$35", "$24", "$35", "$16", "$13"];
const RATINGS_V = [4.8, 4.3, 4.7, 5.0, 5.0, 5.0, 4.9, 5.0, 4.9, 4.5, 4.4, 4.8, 4.7, 3.5, 4.8, 4.0, 4.5, 4.6];
const STUDENTS = ["451,444", "197,637", "435,671", "451,444", "197,637", "1,356,236", "511,123", "211,434", "197,637", "982,941", "154,817", "211,434", "451,444", "982,941", "854", "211,434", "854", "181,811"];

export const COURSES = Array.from({ length: 18 }, (_, i) => ({
    id: i + 1,
    category: CATEGORIES_LIST[i % 4],
    catColor: CAT_COLORS[i % 4],
    image: IMAGES[i % IMAGES.length],
    price: PRICES[i],
    rating: RATINGS_V[i],
    students: STUDENTS[i],
    instructor: "Darrell Steward",
    instructorImg: "https://randomuser.me/api/portraits/men/32.jpg",
    role: "React Developer",
    popRating: "4.9",
    popReviews: "357/814",
    popPrice: "$14.00",
    popOldPrice: "$25.00",
    discount: "56% OFF",
    speaks: "SPEAKS ENGLISH (NATIVE), HINDI (NATIVE) +3",
    bio: "Certified English tutor (TEFL/UK Level 5) with 3+ years of experience helping students communicate with confidence and style. Learn more",
    popular: "Popular. Booked 8 times recently.",
}));